module.exports = __webpack_public_path__ + "static/media/ic_involved_yellow.fb9eba92.svg";